module.exports = __webpack_public_path__ + "img/35_newYouth_zk.cd7ce303.png";